export const vegetationRasterTileConfigs = {
 
  lai: {
    id: "lai",
    isDynamic: true,
    type: "raster",
    sourceId: "lai-raster-source",
    layerId: "lai-raster-layer",
    source: {
      type: "raster",
      tiles: [
        `${process.env.REACT_APP_MAPPER_VEGETATION_BASEURL_V1}/lai/raster/{z}/{x}/{y}.webp`,
      ],
      tileSize: 256,
      minzoom: 0,
      maxzoom: 22,
    },
    layer: {
      type: "raster",
      paint: {
        "raster-opacity": 1,
      },
    },
    popup: {
      enabled: true,
      endpoint: `${process.env.REACT_APP_MAPPER_VEGETATION_BASEURL_V1}/lai/raster/point`,
      labelKey: "layers.items.leafAreaIndex",
      unit: "",
    },
  },
  vegetationHeight: {
    id: "vegetation-height",
    isDynamic: true,
    type: "raster",
    sourceId: "vegetation-height-raster-source",
    layerId: "vegetation-height-raster-layer",
    source: {
      type: "raster",
      tiles: [
        `${process.env.REACT_APP_MAPPER_VEGETATION_BASEURL_V1}/chm/raster/{z}/{x}/{y}.webp`,
      ],
      tileSize: 256,
      minzoom: 0,
      maxzoom: 22,
    },
    layer: {
      type: "raster",
      paint: {
        "raster-opacity": 1,
      },
    },
    popup: {
      enabled: true,
      endpoint: `${process.env.REACT_APP_MAPPER_VEGETATION_BASEURL_V1}/chm/raster/point`,
      labelKey: "layers.items.vegetationHeight",
      unit: "m",
    },
  },
  biomass: {
    id: "biomass",
    isDynamic: true,
    type: "raster",
    sourceId: "biomass-raster-source",
    layerId: "biomass-raster-layer",
    source: {
      type: "raster",
      tiles: [
        `${process.env.REACT_APP_MAPPER_VEGETATION_BASEURL_V1}/biomass/raster/{z}/{x}/{y}.webp`,
      ],
      tileSize: 256,
      minzoom: 0,
      maxzoom: 22,
    },
    layer: {
      type: "raster",
      paint: {
        "raster-opacity": 1,
      },
    },
    popup: {
      enabled: true,
      endpoint: `${process.env.REACT_APP_MAPPER_VEGETATION_BASEURL_V1}/biomass/raster/point`,
      labelKey: "layers.items.biomass",
      unit: "kg/m²",
    },
  },
  totalFuelLoad: {
    id: "total-fuel-load",
    isDynamic: true,
    type: "raster",
    sourceId: "total-fuel-load-raster-source",
    layerId: "total-fuel-load-raster-layer",
    source: {
      type: "raster",
      tiles: [
        `${process.env.REACT_APP_MAPPER_VEGETATION_BASEURL_V1}/tfl/raster/{z}/{x}/{y}.webp`,
      ],
      tileSize: 256,
      minzoom: 0,
      maxzoom: 22,
    },
    layer: {
      type: "raster",
      paint: {
        "raster-opacity": 1,
      },
    },
    popup: {
      enabled: true,
      endpoint: `${process.env.REACT_APP_MAPPER_VEGETATION_BASEURL_V1}/tfl/raster/point`,
      labelKey: "layers.items.totalFuelLoad",
      unit: "kg/m²",
    },
  },
  bareSoil: {
    id: "bare-soil",
    isDynamic: true,
    type: "raster",
    sourceId: "bare-soil-raster-source",
    layerId: "bare-soil-raster-layer",
    source: {
      type: "raster",
      tiles: [
        `${process.env.REACT_APP_MAPPER_VEGETATION_BASEURL_V1}/baresoil/raster/{z}/{x}/{y}.webp`,
      ],
      tileSize: 256,
      minzoom: 0,
      maxzoom: 22,
    },
    layer: {
      type: "raster",
      paint: {
        "raster-opacity": 1,
      },
    },
  },
  coniferous: {
    id: "coniferous",
    isDynamic: true,
    type: "raster",
    sourceId: "coniferous-raster-source",
    layerId: "coniferous-raster-layer",
    source: {
      type: "raster",
      tiles: [
        `${process.env.REACT_APP_MAPPER_VEGETATION_BASEURL_V1}/coniferous/raster/{z}/{x}/{y}.webp`,
      ],
      tileSize: 256,
      minzoom: 0,
      maxzoom: 22,
    },
    layer: {
      type: "raster",
      paint: {
        "raster-opacity": 0.8,
      },
    },
  },
  shrubland: {
    id: "shrubland",
    isDynamic: true,
    type: "raster",
    sourceId: "shrubland-raster-source",
    layerId: "shrubland-raster-layer",
    source: {
      type: "raster",
      tiles: [
        `${process.env.REACT_APP_MAPPER_VEGETATION_BASEURL_V1}/shrubland/raster/{z}/{x}/{y}.webp`,
      ],
      tileSize: 256,
      minzoom: 0,
      maxzoom: 22,
    },
    layer: {
      type: "raster",
      paint: {
        "raster-opacity": 0.8,
      },
    },
  },
  grassland: {
    id: "grassland",
    isDynamic: true,
    type: "raster",
    sourceId: "grassland-raster-source",
    layerId: "grassland-raster-layer",
    source: {
      type: "raster",
      tiles: [
        `${process.env.REACT_APP_MAPPER_VEGETATION_BASEURL_V1}/grassland/raster/{z}/{x}/{y}.webp`,
      ],
      tileSize: 256,
      minzoom: 0,
      maxzoom: 22,
    },
    layer: {
      type: "raster",
      paint: {
        "raster-opacity": 0.8,
      },
    },
    // popup: {
    //   enabled: true,
    //   endpoint: `${process.env.REACT_APP_MAPPER_VEGETATION_BASEURL_V1}/Grassland/point`,
    //   label: "Grassland Coverage",
    //   unit: "%",
    // },
  },
  cropland: {
    id: "cropland",
    isDynamic: true,
    type: "raster",
    sourceId: "cropland-raster-source",
    layerId: "cropland-raster-layer",
    source: {
      type: "raster",
      tiles: [
        `${process.env.REACT_APP_MAPPER_VEGETATION_BASEURL_V1}/cropland/raster/{z}/{x}/{y}.webp`,
      ],
      tileSize: 256,
      minzoom: 0,
      maxzoom: 22,
    },
    layer: {
      type: "raster",
      paint: {
        "raster-opacity": 0.8,
      },
    },
  },
  broadleaf: {
    id: "broadleaf",
    isDynamic: true,
    type: "raster",
    sourceId: "broadleaf-raster-source",
    layerId: "broadleaf-raster-layer",
    source: {
      type: "raster",
      tiles: [
        `${process.env.REACT_APP_MAPPER_VEGETATION_BASEURL_V1}/broadleaf/raster/{z}/{x}/{y}.webp`,
      ],
      tileSize: 256,
      minzoom: 0,
      maxzoom: 22,
    },
    layer: {
      type: "raster",
      paint: {
        "raster-opacity": 0.8,
      },
    },
  },
  pine: {
    id: "pine",
    isDynamic: true,
    type: "raster",
    sourceId: "pine-raster-source",
    layerId: "pine-raster-layer",
    source: {
      type: "raster",
      tiles: [
        `${process.env.REACT_APP_MAPPER_VEGETATION_BASEURL_V1}/pin/raster/{z}/{x}/{y}.webp`,
      ],
      tileSize: 256,
      minzoom: 0,
      maxzoom: 22,
    },
    layer: {
      type: "raster",
      paint: {
        "raster-opacity": 0.8,
      },
    },
  },
  oak: {
    id: "oak",
    isDynamic: true,
    type: "raster",
    sourceId: "oak-raster-source",
    layerId: "oak-raster-layer",
    source: {
      type: "raster",
      tiles: [
        `${process.env.REACT_APP_MAPPER_VEGETATION_BASEURL_V1}/oak/raster/{z}/{x}/{y}.webp`,
      ],
      tileSize: 256,
      minzoom: 0,
      maxzoom: 22,
    },
    layer: {
      type: "raster",
      paint: {
        "raster-opacity": 0.8,
      },
    },
  },
  mixedForest: {
    id: "mixed-forest",
    isDynamic: true,
    type: "raster",
    sourceId: "mixed-forest-raster-source",
    layerId: "mixed-forest-raster-layer",
    source: {
      type: "raster",
      tiles: [
        `${process.env.REACT_APP_MAPPER_VEGETATION_BASEURL_V1}/mixed/raster/{z}/{x}/{y}.webp`,
      ],
      tileSize: 256,
      minzoom: 0,
      maxzoom: 22,
    },
    layer: {
      type: "raster",
      paint: {
        "raster-opacity": 0.8,
      },
    },
  },
    deadFuelMoisture: {
    id: "deadFuel",
    type: "raster",
    isDynamic: true,
    sourceId: "deadFuel-source",
    layerId: "deadFuel-layer",
    source: {
      type: "raster",
      tiles: [
        `${process.env.REACT_APP_MAPPER_VEGETATION_BASEURL_V1}/Dfmc/raster/{z}/{x}/{y}.webp`,
      ],
      tileSize: 256,
      minzoom: 0,
      maxzoom: 22,
    },
    layer: {
      type: "raster",
      paint: {
        "raster-opacity": 0.9,
      },
    },
    popup: {
      enabled: true,
      endpoint: `${process.env.REACT_APP_MAPPER_VEGETATION_BASEURL_V1}/Dfmc/raster/point`,
      labelKey: "layers.items.deadFuel",
      unit: "%",
    },
  },
};
